// ============================================================
// Tipos e enums do sistema de Onboarding/Tutorial
// ============================================================

/** Identificadores dos tutoriais disponíveis na plataforma */
export enum TutorialId {
  INITIAL = 'initial',
  PROFILE = 'profile',
  HOME = 'home',
  TOOLS = 'tools',
  TOOLS_PROFILE = 'tools-profile',
  PROJECTS = 'projects',
  ACTIVITIES = 'activities',
  VIDEOS = 'videos',
  COMMUNITY = 'community',
  CHALLENGES = 'challenges',
  TOURNAMENTS = 'tournaments',
}

/** Tipos de etapas (categorização interna) */
export enum OnboardingStepType {
  VIDEO = 'video',
  TOOLS = 'tools',
  TOOLS_PROFILE = 'tools-profile',
  TUTORIALS = 'tutorials',
  COMMUNITY = 'community',
  CHALLENGES = 'challenges',
  RANKING = 'ranking',
  PROFILE = 'profile',
  WELCOME = 'welcome',
  HOME = 'home',
}

/** Definição de uma etapa do tutorial */
export interface IOnboardingStep {
  id: string;
  type: OnboardingStepType;
  title: string;
  description: string;
  points?: number;
  order: number;
  completed: boolean;
  targetSelector?: string;
  position?: 'top' | 'right' | 'bottom' | 'left' | 'center';
  padding?: number;
  requiredActions?: string[];
}

/** Progresso persistido em localStorage por tutorial */
export interface ITutorialProgress {
  currentStepIndex: number;
  completedSteps: string[];
  completedActions: Record<string, string[]>;
  lastUpdated: number;
}

/** Dados expostos pelo contexto de onboarding */
export interface IOnboardingContextData {
  // Estado
  isOnboardingActive: boolean;
  isSpotlightActive: boolean;
  currentStep: IOnboardingStep | null;
  steps: IOnboardingStep[];
  targetSelector: string | null;
  tooltipPosition: string;
  completedActions: Record<string, string[]>;
  isLoading: boolean;
  activeTutorialId: TutorialId | null;

  // Ações
  startTutorial: (tutorialId: TutorialId) => void;
  startOnboarding: () => void; // atalho para startTutorial(INITIAL)
  skipTutorial: () => void;
  skipOnboarding: () => void; // alias para backward compat
  nextStep: () => void;
  previousStep: () => void;
  completeStep: (stepId: string) => void;
  completeTutorial: () => Promise<void>;
  completeOnboarding: () => Promise<void>; // alias
  markActionCompleted: (stepId: string, actionId: string) => void;
  markCurrentStepActionCompleted: (actionId: string) => void;
  isStepCompleted: (stepId: string) => boolean;
  resetTutorial: () => void;
  resetOnboarding: () => void; // alias
  closeModal: () => void;
  toggleSpotlight: () => void;
}

/** Mapeamento de TutorialId para rota da plataforma */
export const tutorialRouteMap: Record<TutorialId, string> = {
  [TutorialId.INITIAL]: '/home',
  [TutorialId.PROFILE]: '/profile',
  [TutorialId.HOME]: '/home',
  [TutorialId.TOOLS_PROFILE]: '/hardwares/profile',
  [TutorialId.TOOLS]: '/hardwares',
  [TutorialId.PROJECTS]: '/projects',
  [TutorialId.ACTIVITIES]:
    '/projects/:trail_slug/:chapter_id/activity/:activity_slug',
  [TutorialId.VIDEOS]: '/videos',
  [TutorialId.COMMUNITY]: '/community',
  [TutorialId.CHALLENGES]: '/challenges',
  [TutorialId.TOURNAMENTS]: '/tournaments',
};
